import React, { useMemo } from 'react';
import { FormGroup, ControlLabel } from 'react-bootstrap';
import PropTypes from 'prop-types';

import Tooltip from '../../../../../../../../components/Tooltip';

import * as types from '../../reducer/constants';
import { disableRefillCheck } from './helper';

const FieldRefillCheck = ({ form, dispatchServiceData }) => {
  const {
    refill: { refill_check, refill_type, refill_minimal_quantity, refill_maximum_quantity_percent },
  } = form;
  const selectedValue = refill_check ? '1' : '0';
  const isDisabled = useMemo(() => disableRefillCheck(refill_type), [refill_type]);

  const onChange = (e) => {
    const value = e.target.value === '1';
    dispatchServiceData({ type: types.EDIT_SERVICES_FORM_CHANGE_REFILL_CHECK, value });
    if (!value) {
      dispatchServiceData({ type: types.EDIT_SERVICES_FORM_CHANGE_REFILL_MINIMUM_QUANTITY, value: null });
      dispatchServiceData({ type: types.EDIT_SERVICES_FORM_CHANGE_REFILL_MAXIMAL_QUANTITY, value: null });
      dispatchServiceData({ type: types.EDIT_SERVICES_FORM_CHANGE_REFILL_COUNT, value: null });
      dispatchServiceData({ type: types.EDIT_SERVICES_FORM_CHANGE_REFILL_REJECTION, value: false });
    }
  };

  /**
   * Если refill_check = false и refill_minimal_quantity = 0
   * Надо поменять refill_minimal_quantity на null
   * Чтобы проходила валидация бека
   */
  if (!refill_check && refill_minimal_quantity === 0) {
    dispatchServiceData({ type: types.EDIT_SERVICES_FORM_CHANGE_REFILL_MINIMUM_QUANTITY, value: null });
  }

  /**
   * Если refill_check = false и refill_maximal_quantity = 0
   * Надо поменять refill_maximal_quantity на null
   * Чтобы проходила валидация бека
   */
  if (!refill_check && refill_maximum_quantity_percent === 0) {
    dispatchServiceData({ type: types.EDIT_SERVICES_FORM_CHANGE_REFILL_MAXIMAL_QUANTITY, value: null });
  }

  return (
    <>
      <FormGroup>
        <ControlLabel htmlFor="refill_check">
          Refill check
          {' '}
          <Tooltip
            placement="top"
            text={(
              <p>
                The system will check whether an
                <br />
                {' '}
                order requires a refill. If yes - it will
                <br />
                {' '}
                determine the quantity needed to
                <br />
                {' '}
                be refilled. Refill check will not
                <br />
                {' '}
                work if there's an error in an order
                <br />
                {' '}
                start count. It is a paid feature.
                <br />
                {' '}
                One query deducts one parsing
                <br />
                {' '}
                credit.
              </p>
            )}
            tooltipClass="tooltip__top"
          >
            <span className="fas fa-info-circle cursor-help" />
          </Tooltip>
        </ControlLabel>
        <select name="refill_check" id="refill_check" className="form-control" disabled={isDisabled} value={selectedValue} onChange={onChange}>
          <option value="1">Yes</option>
          <option value="0">No</option>
        </select>
      </FormGroup>
    </>
  );
};

FieldRefillCheck.propTypes = {
  form: PropTypes.object,
  dispatchServiceData: PropTypes.func,
};

export default FieldRefillCheck;
